(function() {
  const body = document.querySelector('.article-template__content');
  if (!body) return;

  const postTitle = document.title || '';
  const postUrl = window.location.pathname || '';

  const rawText = (postTitle + ' ' + postUrl).toLowerCase();
  const keywords = rawText.split(/\W+/).filter(w => w.length > 2);

  fetch('/collections/all/products.json?limit=250')
    .then(r => r.json())
    .then(data => {
      // Only use products with an image and at least one
      // available variant. Fully sold-out products are excluded.
      let products = data.products.filter(p =>
        p.images.length > 0 &&
        p.variants.some(v => v.available)
      );

      // Do not create product rows if no in-stock products were found.
      if (products.length === 0) return;

      products = products.map(p => {
        const titleLower = p.title.toLowerCase();
        const handleLower = p.handle.toLowerCase();
        let score = 0;

        keywords.forEach(k => {
          if (titleLower.includes(k)) score += 2;
          if (handleLower.includes(k)) score += 1;
        });

        return { ...p, _score: score };
      });

      products.sort((a, b) => {
        if (b._score !== a._score) {
          return b._score - a._score;
        }

        return Math.random() - 0.5;
      });

      // Find all eligible H2 headings in the article.
      const allH2s = Array.from(body.querySelectorAll('h2'));

      const eligibleH2s = allH2s.filter(h2 => {
        const prev = h2.previousElementSibling;

        const hasImage =
          prev &&
          (
            prev.tagName === 'IMG' ||
            prev.querySelector('img') ||
            prev.classList.contains('wff-grid') ||
            (prev.tagName === 'P' && prev.querySelector('img')) ||
            (prev.tagName === 'DIV' && prev.querySelector('img')) ||
            (prev.tagName === 'FIGURE' && prev.querySelector('img'))
          );

        return !hasImage;
      });

      // Insert a product row before every other eligible H2,
      // beginning with the second eligible H2.
      const insertBefore = eligibleH2s.filter((_, i) => i % 2 === 1);

      let idx = 0;

      insertBefore.forEach(h2 => {
        const p1 = products[idx % products.length];
        idx++;

        const p2 = products[idx % products.length];
        idx++;

        const p3 = products[idx % products.length];
        idx++;

        const grid = document.createElement('div');
        grid.className = 'wff-grid';

        grid.innerHTML =
          wffCard(p1) +
          '<span class="wff-desktop-only">' +
          wffCard(p2) +
          '</span>' +
          '<span class="wff-desktop-only">' +
          wffCard(p3) +
          '</span>';

        h2.parentNode.insertBefore(grid, h2);
      });
    })
    .catch(error => {
      console.error('Unable to load article products:', error);
    });

  function wffCard(p) {
    const rawPrice = parseFloat(p.variants[0].price);
    const price = isNaN(rawPrice) ? '' : '$' + rawPrice.toFixed(2);

    const img = p.images[0].src.replace(
      /(\.[^.]+)$/,
      '_400x$1'
    );

    return `
      <a
        href="/products/${p.handle}"
        target="_blank"
        rel="noopener"
        class="wff-card"
      >
        <div class="wff-img-wrap">
          <img
            src="${img}"
            alt="${p.title}"
            loading="lazy"
          >
        </div>

        <div class="wff-body">
          <div class="wff-title">${p.title}</div>
          <div class="wff-price">
            ${price ? 'From ' + price : ''}
          </div>
          <div class="wff-btn">Shop Now &rarr;</div>
        </div>
      </a>
    `;
  }
})();